<template>
    <div class="page-container">
        <!-- 未登录状态 -->
        <!-- <div class="page-top">
            <div class="uinfo-block">
                <div class="user-icon" ></div>
                <div class="center-box">
                    <div class="user-name">欢迎来到御粮世家</div>
                </div>
            </div>
            <router-link class="btn-login" to="/login">登录</router-link>
        </div> -->
        <!-- 已登陆状态 -->
        <div class="page-top-logined">
            <div class="page-top" style="padding-bottom:0;" @click="jumpPage('account-info')">
                <div class="uinfo-block">
                    <img :src="userInfo.url" class="user-icon" />
                    <div class="center-box">
                        <div class="user-name">{{
                                userInfo.level == 1 ? '普通用户' : 
                                userInfo.level == 2 ? userInfo.userName : 
                                userInfo.level == 3 ? userInfo.userName : 
                                userInfo.level == 4 ? '战略合伙人' : '推荐人'
                            }}</div>
                        <div class="city-phone">
                            <!-- <span><van-icon size="16" color="#fff" name="location-o" /> 上海</span> -->
                            <span><!-- <van-icon size="16" color="#fff" name="phone-o" /> --> {{userInfo.mobile}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="qr-block">
                    <div class="qr-wrapper">
                        <van-icon size="20" color="#fff" name="qr" />
                    </div>
                </div> -->
                <div class="see-bill">
                    <span>查看账户信息</span>
                </div>
            </div>

            <!-- 邀请码 -->
            <div class="sharecode-block">
                <span>邀请码：{{userInfo.inviteCode}}</span>
                <div class="btn-copy" v-clipboard:copy="userInfo.inviteCode" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</div>
            </div>
        </div>
        <div class="page-bottom">
            <div class="bottom-title">个人中心</div>
            <div class="menu-list">
                <template v-if="userInfo.level != 5">
                    <div class="menu-item" @click="renzheng" v-if="userInfo.status == 2">
                        <div class="item-left">
                            <img src="../assets/icon-smrz.png" class="item-icon">
                            <div class="item-text">实名认证</div>
                        </div>
                        <div class="item-right">
                            <span style="font-size:14px;color:#3088F5">去认证</span>
                            <van-icon name="arrow" color="#C8C8C8" size="18" />
                        </div>
                    </div>
                    <div class="menu-item" v-else>
                        <div class="item-left">
                            <img src="../assets/icon-smrz.png" class="item-icon">
                            <div class="item-text">实名认证</div>
                        </div>
                        <div class="item-right">
                            <span style="font-size:14px;color:#3088F5">{{userInfo.status == 3 ? '认证中' : '已认证'}}</span>
                            <!-- <van-icon name="arrow" color="#C8C8C8" size="18" /> -->
                        </div>
                    </div>

                    <div class="menu-item" @click="qianyue" v-if="userInfo.status == 2 || userInfo.status == 3 ||userInfo.status == 7 || userInfo.status == 6 || userInfo.status == 8 || userInfo.status == 11">
                        <div class="item-left">
                            <img src="../assets/icon-reward-rules.png" class="item-icon">
                            <div class="item-text">合伙人签约</div>
                        </div>
                        <div class="item-right">
                            <span style="font-size:14px;color:#3088F5">{{userInfo.status == 6 ? '签约中' : '待签约'}}</span>
                            <van-icon name="arrow" color="#C8C8C8" size="18" />
                        </div>
                    </div>
                    <div class="menu-item" v-else>
                        <div class="item-left">
                            <img src="../assets/icon-jxsqy.png" class="item-icon">
                            <div class="item-text">合伙人签约</div>
                        </div>
                        <div class="item-right">
                            <span style="font-size:14px;color:#3088F5" v-if="userInfo.status == 1 || userInfo.status == 9" @click="jumpHt">查看合同</span>
                            <van-icon name="arrow" color="#C8C8C8" size="18" />
                        </div>
                    </div>
                </template>
                
                <div class="menu-item" v-if="userInfo.level != 1 && userInfo.level != 5" @click="jumpPage('business-card')">
                    <div class="item-left">
                        <img src="../assets/icon-dealer-detail.png" class="item-icon">
                        <div class="item-text">经销商名片</div>
                    </div>
                    <van-icon name="arrow" color="#C8C8C8" size="18" />
                </div>
                <div class="menu-item" v-if="userInfo.level == 5" @click="showSjhhr = true">
                    <div class="item-left">
                        <img src="../assets/icon-dealer-detail.png" class="item-icon">
                        <div class="item-text">升级为合伙人</div>
                    </div>
                    <van-icon name="arrow" color="#C8C8C8" size="18" />
                </div>
                <div class="menu-item" @click="jumpPage('policy-center')">
                    <div class="item-left">
                        <img src="../assets/icon-rule-center.png" class="item-icon">
                        <div class="item-text">政策中心</div>
                    </div>
                    <van-icon name="arrow" color="#C8C8C8" size="18" />
                </div>
                <div class="menu-item" @click="showLayer = true">
                    <div class="item-left">
                        <img src="../assets/icon-invoice-manage.png" class="item-icon">
                        <div class="item-text">发票管理</div>
                    </div>
                    <van-icon name="arrow" color="#C8C8C8" size="18" />
                </div>
                <div class="menu-item" @click="showLayer = true">
                    <div class="item-left">
                        <img src="../assets/icon-contact-service.png" class="item-icon">
                        <div class="item-text">联系客服</div>
                    </div>
                    <van-icon name="arrow" color="#C8C8C8" size="18" />
                </div>
            </div>
        </div>
        <!-- 提示实名认证的弹层 -->
        <van-dialog 
            v-model="showRz"
            :close-on-click-overlay=true
            title="系统提示"
            message='您还未实名认证，快去认证吧'
            confirmButtonText='去认证'
            confirmButtonColor='#3088F5'
        >
        </van-dialog>
        <!-- 认证角色选择弹层 -->
        <van-dialog 
            v-model="showJs"
            title="请先选择认证角色"
            :close-on-click-overlay=true
            confirmButtonText='企业'
            confirmButtonColor='#3088F5'
            :show-cancel-button=true
            cancel-button-text='个人'
            cancel-button-color='#3088F5'
            @confirm="torenzheng('2')"
            @cancel="torenzheng('1')"
        >
        </van-dialog>
        <!-- 提示升级为合伙人的弹层 -->
        <van-dialog 
            v-model="showSjhhr"
            :close-on-click-overlay=true
            title="系统提示"
            message='申请升级后请及时认证签约补缴货款'
            confirmButtonText='确认升级'
            confirmButtonColor='#3088F5'
            :show-cancel-button=true
            cancelButtonText="取消"
            cancelButtonColor='#3088F5'
            @confirm="updrageLevel()"
        >
        </van-dialog>
        <!-- 签约的合伙人角色选择弹层 -->
        <!-- <van-dialog 
            v-model="showHhrjs"
            :close-on-click-overlay=true
            title="签约提示"
            confirmButtonText='确认'
            confirmButtonColor='#3088F5'
            :show-cancel-button=true
            cancel-button-text='取消'
            cancel-button-color='#3088F5'
            @confirm="toQianyue"
        >
            <div class="dialog-wrapper">
                <div class="dialog-tit">请选择您的合伙人类型</div>
                <van-radio-group v-model="userLevel">
                    <van-radio name="3">高级合伙人(18万起)</van-radio>
                    <van-radio name="2">初级合伙人(4.2万起)</van-radio>
                </van-radio-group>
                <div class="dialog-tit">请输入您实际转账的订货金额</div>
                <input type="number" @input="accountInput" class="account-input" v-model="accountDh">
                <div class="dialog-notice">该金额即为签约合同中的订货金额</div>
            </div>
        </van-dialog> -->
        <van-overlay :show='showHhrjs' @click="closeHhr">
            <div class="layer-wrapper">
                <div class="qianyue-layer" @click.stop>
                    <div class="layer-title">签约提示</div>
                    <div class="layer-bottom">
                        <div class="content-title">请选择您的合伙人类型</div>
                        <van-radio-group v-model="userLevel">
                            <van-radio name="3">高级合伙人(18万起)</van-radio>
                            <van-radio name="2">初级合伙人(4.2万起)</van-radio>
                        </van-radio-group>
                        <div class="content-title" style="margin-bottom:12px;">请输入您实际转账的订货金额</div>
                        <input type="number" @input="accountInput" class="account-input" v-model="accountDh">
                        <div class="dialog-notice">注：该金额即为签约合同中的订货金额</div>
                        <div class="btn-line">
                            <div class="btn-cancel" @click="closeHhr">取消</div>
                            <div class="btn-qianyue" @click="toQianyue">去签约</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- 客服弹层 -->
        <van-overlay :show="showLayer" @click="showLayer = false">
            <div class="layer-wrapper">
                <div class="layer-content" @click.stop>
                    <img src="../assets/login-icon-service.png" class="service-icon" alt="联系客服" />
                    <div class="layer-main-title">请联系客服</div>
                    <div class="service-number">4001017057</div>
                    <div class="service-time">客服工作时间9:00-18:00</div>
                    <div class="btn-group">
                        <div class="btn-cancel btn-item" @click="showLayer = false">取消</div>
                        <a href="tel:4001017057" class="btn-call btn-item">立即呼叫</a>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- loading弹层 -->
        <van-overlay :show="showLoading">
            <div class="loading-wrapper">
                <van-loading type="spinner" size="50" color="#fff" vertical>正在跳转至第三方...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { Icon,Notify,Dialog,RadioGroup, Radio,Toast,Overlay,Loading } from 'vant'

import $http from '../lib/request'
import config from '../config'
import { setLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            userInfo:{},//userInfo.level:1 潜在合伙人，2 初级合伙人，3 高级合伙人，4 战略合伙人
            showRz:false,//实名认证弹层是否显示
            showJs:false,//实名认证角色选择弹层
            showHhrjs:false,//选择合伙人角色弹层
            userLevel:'',//合伙人角色：3 高级合伙人，2 初级合伙人
            showLayer:false,//是否展示客服弹层
            accountDh:'',//订货金额
            loading:false,//正在请求接口
            showLoading:false,//是否显示loading弹层
            showSjhhr:false,//是否展示升级合伙人弹层
        }
    },
    components:{
        [Icon.name]:Icon,
        [Notify.name]:Notify,
        [Dialog.Component.name]:Dialog.Component,
        [RadioGroup.name]:RadioGroup,
        [Radio.name]:Radio,
        [Toast.name]:Toast,
        [Overlay.name]:Overlay,
        [Loading.name]:Loading
    },
    deactivated(){
        window.removeEventListener('pageshow',this.hideLoading);
    },
    activated(){
        window.addEventListener('pageshow',this.hideLoading);
        this.checkuData();
        //认证/签约回调进来需执行调操作
        let queryData=this.$route.query;
        if(queryData.transactionNo){
            $http({
                method:'post',
                data:{
                    type:1,
                    transactionNo:queryData.transactionNo,
                    authenticationType:queryData.authenticationType,
                    status:queryData.status
                },
                url:config.api.updateUserStatus
            }).then(res=>{
                if(res.errno == 0){
                    this.checkuData();
                }else{
                    Toast(res.errmsg)
                }
            })
            setTimeout(()=>{
                this.checkuData();
            },3000);
        }
        if(queryData.transaction_id){
            $http({
                method:'post',
                data:{
                    type:2,
                    resultCode:queryData.result_code,
                    resultDesc:queryData.result_desc
                },
                url:config.api.updateUserStatus
            }).then(res=>{
                if(res.errno == 0){
                    this.checkuData();
                }else{
                    Toast(res.errmsg)
                }
            })
            setTimeout(()=>{
                this.checkuData();
            },3000);
        }
        
    },
    
    methods:{
        hideLoading(){
            this.showLoading=false;
        },
        updrageLevel(){
             $http({
                method:'post',
                url:config.api.updateUserLevel
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        closeHhr(){
            this.showHhrjs = false;
            this.accountDh='';
            this.userLevel='';
        },
        accountInput(){
            this.accountDh=parseFloat(this.accountDh);
        },
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        },
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        qianyue(){
            //没认证弹出去认证提示框
            if(this.userInfo.status == 2 || this.userInfo.status == 3){
                this.showRz=true;
                return;
            }
            if(this.userInfo.status == 6){
                Toast('正在签约中，请耐心等待');
                return;
            }
            this.showHhrjs=true;
            
        },
        toQianyue(){
            if(!this.userLevel){
                Toast('请选择合伙人角色！');
                return;
            }
            if(!this.loading){
                this.loading=true;
                $http({
                    method:'post',
                    url:config.api.qianyue,
                    data:{
                        userLevel:this.userLevel,
                        amount:parseFloat(this.accountDh).toFixed(2)
                    }
                }).then(res=>{
                    if(res.errno == 0){
                        this.showLoading=true;
                        window.location.href=res.data
                    }else{
                        Toast(res.errmsg);
                    }
                    this.loading=false;
                })
                .catch(()=>{
                    this.loading=false;
                })
            }
            
        },
        renzheng(){
            this.showJs=true;
        },
        torenzheng(type){
            if(!this.loading){
                this.loading=true;
                $http({
                    method:'post',
                    data:{
                        accountType:type
                    },
                    url:config.api.pervRenzheng
                }).then(res=>{
                    if(res.errno == 0){
                        this.showLoading=true;
                        window.location.href=res.data
                    }else{
                        Toast(res.errmsg);
                    }
                    this.loading=false;
                })
                .catch(()=>{
                    this.loading=false;
                });
            }
            
        },
        jumpPage(name){
            this.$router.push({
                name:name
            });
        },
        jumpHt(){
            $http({
                method:'post',
                url:config.api.getSignUrl
            }).then(res=>{
                if(res.errno == 0){
                    window.location.href=res.data.signUrl;
                    this.showLoading=true;
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-radio-group{
    margin:20px 0;
}
::v-deep .van-radio{
    margin-bottom: 15px;
}
.layer-wrapper,.loading-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
}
.qianyue-layer{
    border-radius: 4px;
    width:300px;
    .layer-title{
        width:300px;
        height:70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        background:url('../assets/qy-layer-bg.png') no-repeat center center;
        background-size: 300px 70px;
    }
    .layer-bottom{
        background:#fff;
        padding:20px 30px;
        .content-title{
            font-size: 16px;
            color:#333;
            line-height: 22px;
            font-weight: 500;
        }
        .account-input{
            width:242px;
            height:38px;
            box-sizing: border-box;
            padding:0 10px;
            line-height: 38px;
            border-radius: 4px;
            background:#fff;
            border:1px solid #eaeaea;
        }
        .dialog-notice{
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
            color:#e12323;
            margin-bottom: 20px;
        }
        .btn-line{
            margin-top:30px;
            display: flex;
            justify-content: center;
            align-items: center;
            .btn-cancel{
                width: 90px;
                height: 30px;
                line-height: 30px;
                background: #FFFFFF;
                border-radius: 26px;
                border: 1px solid #DCDADA;
                color:#333;
                font-size: 14px;
                text-align: center;
                margin-right: 20px;
            }
            .btn-qianyue{
                width: 90px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
                border-radius: 26px;
                color:#fff;
                font-size: 14px;
                text-align: center;
            }
        }
    }
}
.page-container{
    min-height: 100vh;
    .page-top{
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:25px 15px;
        position: relative;
        .qr-block{
            width: 50px;
            height: 38px;
            background: rgba(178,225,255,0.19);
            position: absolute;
            right:0;
            // top:calc(50% - 20px);
            // transform: translateY(-50%);
            @media screen and (max-width: 750px){
                border-top-left-radius: 26px;
                border-bottom-left-radius: 26px;
            }
            .qr-wrapper{
                width:30px;
                height:30px;
                position: absolute;
                top:4px;
                left:4px;
                background:#198FFC;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .see-bill{
            position: relative;
            right:-15px;
            font-size: 12px;
            color:#fff;
            text-align: center;
            width: 94px;
            height: 25px;
            line-height: 25px;
            background: linear-gradient(270deg, #3493F8 0%, #3CA7FE 100%);
            border-radius: 14px 0px 0px 14px;
        }
        .uinfo-block{
            width:208px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .user-icon{
                width:60px;
                height: 60px;
                margin-right: 15px;
                background: #D8D8D8;
                @media screen and (max-width: 750px){
                    border-radius: 50%;
                }
            }
            .center-box{
                max-width: 190px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .user-name{
                    font-size: 18px;
                    color:#fff;
                    font-weight: 500;
                    line-height: 25px;
                }
                .city-phone{
                    color:#fff;
                    font-size: 12px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-top: 10px;
                    & > span{
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-end;
                        margin-right: 15px;
                    }
                }
            }
        }
        .btn-login{
            width: 70px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #EDF5FF;
            box-shadow: 0px 2px 3px 0px rgba(48, 136, 245, 0.53);
            font-size: 14px;
            color:#3088f5;
            @media screen and (max-width: 750px){
                border-radius: 26px;
            }
        }
    }
    .page-top-logined{
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
    }
    .sharecode-block{
        width:343px;
        height:64px;
        background:#3C4055;
        border-radius: 16px 16px 0px 0px;
        margin:0 auto;
        margin-top: 20px;
        box-sizing: border-box;
        padding:0 30px;
        @include flex-between();
        &>span{
            font-size: 15px;
            line-height: 21px;
            color:#DBC39E;
            font-weight: 500;
        }
        .btn-copy{
            width: 60px;
            height: 26px;
            line-height: 26px;
            background: linear-gradient(320deg, #EFE3CD 0%, #DBC39E 100%);
            border-radius: 26px;
            text-align: center;
            font-size: 12px;
            color:#492e16;
        }
    }
    .page-bottom{
        background:#fff;
        padding:30px 25px;
        .bottom-title{
            color:#333;
            font-size: 16px;
            line-height: 22px;
        }
        .menu-list{
            .menu-item{
                margin-top: 25px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .item-left{
                    width:200px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .item-icon{
                        width:22px;
                        height:22px;
                        margin-right: 10px;
                    }
                    .item-text{

                    }
                }
                .item-right{
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                }
            }
        }
    }
    .layer-wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        height:100%;
    }
    .layer-content{
        width: 316px;
        box-sizing: border-box;
        padding:20px;
        background:#fff;
        border-radius: 6px;
        text-align: center;
        .service-icon{
            width:90px;
            height:84px;
            margin:8px auto;
            display: block;
        }
        .layer-main-title{
            color:#333;
            font-size: 14px;
            line-height: 20px;
        }
        .service-number{
            color:#333;
            font-weight: 500;
            margin:4px 0;
            font-size: 18px;
            line-height: 26px;
        }
        .service-time{
            color:#3088f5;
            font-size: 14px;
            line-height: 18px;
        }
        .btn-group{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 26px;
            .btn-item{
                width:132px;
                height:40px;
                line-height: 40px;
                border-radius: 26px;
                font-size: 16px;
                &.btn-cancel{
                    border:1px solid #e7e7e7;
                }
                &.btn-call{
                    background: linear-gradient(296deg, #5EBDFB 0%, #3088F5 100%);
                    color: #fff;
                }
            }
        }
    }
    .dialog-wrapper{
        padding-left: 20px;
        margin-top: 20px;
        text-align: left;
        .dialog-tit{
            color:#333;
            line-height: 22px;
            font-size: 16px;
            font-weight: 500;
        }
        .account-input{
            width:250px;
            height:38px;
            padding:0 10px;
            line-height: 38px;
            border-radius: 4px;
            background:#fff;
            border:1px solid #eaeaea;
            margin-top: 12px;
        }
        .dialog-notice{
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
            color:#e12323;
            margin-bottom: 20px;
        }
    }
}
</style>